(function () {
  function elements() {
    var checkbox = document.getElementById('pab-proof-timeline-agree');
    return { checkbox: checkbox, card: document.querySelector('[data-pab-proof-timeline]'), error: document.getElementById('pab-proof-timeline-error') };
  }
  function prompt() {
    var ui = elements();
    if (!ui.checkbox || !ui.card) return;
    ui.card.classList.add('is-invalid');
    ui.checkbox.setAttribute('aria-invalid', 'true');
    if (ui.error) ui.error.hidden = false;
    ui.card.scrollIntoView({ behavior: 'auto', block: 'center' });
    ui.checkbox.focus({ preventScroll: true });
  }
  function reset() {
    var ui = elements();
    if (ui.checkbox) { ui.checkbox.checked = false; ui.checkbox.removeAttribute('aria-invalid'); }
    if (ui.card) ui.card.classList.remove('is-invalid');
    if (ui.error) ui.error.hidden = true;
  }
  window.PABProofTimeline = { prompt: prompt, reset: reset };
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('#reset, [data-pab-mobile-reset-confirm-go]')) reset();
    if (!target.closest('#add-cart, #mobile-cart, #customOrderForm .add-to-cart-btn')) return;
    var ui = elements();
    if (ui.checkbox && !ui.checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      prompt();
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.id !== 'pab-proof-timeline-agree') return;
    var ui = elements();
    if (ui.checkbox.checked) {
      ui.checkbox.removeAttribute('aria-invalid');
      if (ui.card) ui.card.classList.remove('is-invalid');
      if (ui.error) ui.error.hidden = true;
    }
  });
  window.addEventListener('pageshow', reset);
})();
